module.exports = __webpack_public_path__ + "fonts/Roboto-400-cyrillic-ext31.3004e52.woff2";